module.exports = __webpack_public_path__ + "static/media/ummaty-logo.2ee08fad.png";